/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

import Accordion from './app/accordion.js';

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
  }

  growApp.prototype.fixCalendar = function () {
    const targetWrapper = $('#calendar')
  }

   growApp.prototype.createAccordion = function () {

    const list = $(".c-block-calendar #dataList");
    if (!$(list).length) {
      return;
    }

    const titles = $(list).find("h3");
    const data = $(list).find(".irGroup");
    const accordionWrapper = $(`<div class='c-accordion-ir is-special'></div>`);

    for (let i = 0; i < 6; i++) {
      if (!titles[i] || !data[i]) break;
      const block = $("<div class='c-accordion-ir__block js-accordion'></div>");
      const title = $("<div class='c-accordion-ir__head' data-accordion-title='accordion-title'></div>").append($("<div class='c-accordion-ir__title'></div>").append($(titles[i]).text()));
      const content = $("<div class='c-accordion-ir__content' data-accordion-content='accordion--text'></div>").append($("<div class='c-accordion-ir__content-inner'></div>").append($("<div class='c-accordion-ir__content-text'></div>").append($(data[i]).html())));
      $(block).append(title);
      $(block).append(content);
      $(accordionWrapper).append(block);
    }

    $(list).html(accordionWrapper);
    $(list).addClass("is-visible");
    new Accordion();
  }

  growApp.prototype.wrapContent = function () {
    const container = $(".c-news.is-bg-color").find("#eirArea");
    if (!container.length) return;
    const download = $("#download");
    const pnex = $("#pnex");
    if(!$(download).length && !$(pnex).length) return;

    if (!$(pnex).length) {
      const newContainer = $("<div class='c-block-ir-wrapper'></div>");
      $(newContainer).append(download);
      $(container).append(newContainer);
      return;
    }

    const newContainer = $("<div class='c-block-ir-wrapper'></div>");
    $(newContainer).append(download).append(pnex);
    $(container).append(newContainer);
  }

  growApp.prototype.cookie = function () {
    class Cookie {
      constructor(target, button) {
        this.target = target;
        this.button = button;
        this.fetchDom();
        this.check();
      }

      fetchDom() {
        this.targetEle = $(this.target);
        this.buttonEle = $(this.button);
      }

      check() {
        if (!this.targetEle || !this.buttonEle) {
          return false;
        }

        if (sessionStorage.getItem('cookie')){
          this.targetEle.addClass("is-hide");
        }

        this.run();
      }

      run() {
        this.buttonEle.on("click", () => {
          this.targetEle.addClass("is-hide");
          sessionStorage.setItem('cookie', true);
        });
      }
    }
    new Cookie("#cookie", ".c-block-cookie__button");
  };

  $(function () {
    var app = new growApp();
    app.myCode();
    app.fixCalendar();
    app.createAccordion();
    app.wrapContent();
    app.cookie();
  });
})(jQuery);
